import { useQuery } from '@tanstack/react-query';
import { ApiError, apiFetch } from '../lib/api';

export interface Me {
  readonly user_id: string;
  readonly agente_id: string;
  readonly tenant_id: string;
  readonly email: string;
  readonly cargo: string;
}

export const useSession = () =>
  useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await apiFetch<Me>('/v1/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
  });
